import React, { useState, useEffect } from 'react';
import useHeaderVisibility from '../hooks/useHeaderVisibility';
import '../components/features/MedicalQuiz/MedicalQuizStyles.css';
import MedicalQuiz from '../components/features/MedicalQuiz/MedicalQuiz';
import { FaRedo, FaChartLine } from 'react-icons/fa';

function MedicalQuizPage() {
  // Refresh key to re-mount the quiz
  const [resetKey, setResetKey] = useState(Date.now());

  // Header visibility for progress bar "fixing"
  const isHeaderVisible = useHeaderVisibility();
  const progressClasses = !isHeaderVisible ? 'fixed' : '';

  // Track progress (0–100)
  const [progress, setProgress] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Reset the quiz by changing the key, forcing a re-mount
  const resetQuiz = () => {
    setResetKey(Date.now());
    setProgress(0);
  };

  // Callback to update progress from child (MedicalQuiz)
  const handleProgressUpdate = (newProgress) => {
    // Round down to whole number
    const wholeNumberProgress = Math.floor(newProgress);
    
    setProgress(wholeNumberProgress);
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 200);
  };

  // Add class to body for proper spacing
  useEffect(() => {
    document.body.classList.add('quiz-page-active');
    
    return () => {
      document.body.classList.remove('quiz-page-active');
    };
  }, []);

  return (
    <div className="quiz-page medmatch-quiz-root">
      {/* NEW HERO HEADER (homepage aesthetic) */}
      <header className="medmatch-hero">
        <h1 className="medmatch-hero-title">
          Workstyle <span className="mm-gradient-text">Alignment</span> Quiz
        </h1>
        <p className="medmatch-hero-sub">
          Profile your procedural intensity, acuity, teamwork dynamics, patient continuity, and pathway priorities to surface specialty fit.
        </p>
        <div className="medmatch-hero-ctas">
          <a className="mm-cta-secondary" href="/quiz-choice">Other Quizzes</a>
          <a className="mm-cta-ghost" href="/home">Home</a>
        </div>
      </header>

      {/* Utility Buttons */}
      <button className="refresh-button" onClick={resetQuiz} title="Reset quiz">
        <FaRedo />
        <span>Refresh</span>
      </button>

      {/* Progress Bar with enhanced tracking */}
      <div className={`progress-bar-container ${progressClasses}`}>
        <div className="progress-bar-content">
          <div className="progress-stats">
            <span className="progress-label">
              <FaChartLine /> Quiz Progress
            </span>
            <span className="progress-percentage">{progress}%</span>
          </div>
          <div className="progress-bar">
            <div 
              className={`progress ${isAnimating ? 'animating' : ''}`} 
              style={{ width: `${progress}%` }} 
            />
          </div>
        </div>
      </div>

      {/* Render MedicalQuiz, pass progress callback */}
      <MedicalQuiz
        key={resetKey}
        onProgressChange={handleProgressUpdate}
      />
    </div>
  );
}

export default MedicalQuizPage;

